<template>
  <v-container>
    <h1 class="primary--text font-weight-bold pb-4">Add Promotion</h1>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(onSave)" ref="promotionForm">
        <v-row>
          <v-col cols="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Landlord"
              rules="required"
            >
              <v-autocomplete
                outlined
                dense
                :error-messages="errors"
                :items="landlordList"
                :loading="$apollo.queries.getLandlords.loading"
                :search-input.sync="searchKey"
                :filter="filterLandlord"
                :item-text="showFullName"
                item-value="_id"
                v-model="selectedLandlordId"
                label="Select Landlord"
              >
                <template #label>
                  <span class="red--text"><strong>* </strong></span>Select
                  Landlord
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col cols="6" v-if="selectedLandlordId">
            <ValidationProvider
              v-slot="{ errors }"
              name="property"
              rules="required"
            >
              <v-select
                :error-messages="errors"
                outlined
                dense
                :loading="dataLoading"
                :items="propertyListOfSelectedLandlord"
                item-text="nameEn"
                item-value="_id"
                no-data-text="No Properties"
                v-model="selectedPropertyId"
                label="Select Property"
              >
                <template #label>
                  <span class="red--text"><strong>* </strong></span>Select
                  Property
                </template>
              </v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="selectedPropertyId">
          <v-col cols="6">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Start Date"
                  rules="required"
                >
                  <v-text-field
                    :disabled="alreadyOnPromotion"
                    v-model="fromDate"
                    :error-messages="errors"
                    :label="alreadyOnPromotion ? 'Started Date' : 'Start Date'"
                    append-icon="mdi-calendar"
                    :loading="dataLoading"
                    outlined
                    class="white my-2"
                    flat
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ alreadyOnPromotion ? "Started Date" : "Start Date" }}
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
              <v-date-picker
                v-model="fromDate"
                :min="new Date().toISOString()"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="End Date"
                  rules="required"
                >
                  <v-text-field
                    v-model="toDate"
                    :label="alreadyOnPromotion ? 'Extend Date' : 'End Date'"
                    :error-messages="errors"
                    append-icon="mdi-calendar"
                    :loading="dataLoading"
                    outlined
                    class="white my-2"
                    flat
                    readonly
                    dense
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ alreadyOnPromotion ? "Extend Date" : "End Date" }}
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
              <v-date-picker
                @input="menu2 = false"
                :min="fromDate"
                v-model="toDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row v-if="fromDate && toDate">
          <v-col cols="6">
            <v-text-field
              v-model="calculatedPromotionCharge"
              label="Promotion Charge"
              append-icon="mdi-cash"
              suffix="KD"
              outlined
              hide-details
              class="white my-2 numberClass"
              flat
              readonly
              dense
            >
              <template #label>
                <span class="red--text"><strong>* </strong></span>Promotion
                Charge
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="calculatedPromotionCharge">
          <v-btn
            depressed
            class="white--text rounded-lg mx-3"
            color="primary"
            type="submit"
            :disabled="paymentUrl ? true : false"
            :loading="btnLoading"
          >
            Add Promotion
          </v-btn>
          <v-btn
            depressed
            @click="sharePaymentLink"
            :disabled="paymentUrl ? false : true"
            class="white--text rounded-lg mx-3"
          >
            Share Payment Link
          </v-btn>
          <v-btn
            depressed
            @click="clearForm"
            class="white--text"
            color="primary"
          >
            Clear
          </v-btn>
        </v-row>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>
<script>
import moment from "moment";
import { createPromotionByAdmin } from "../../methods/create_promotion_by_admin";
export default {
  data() {
    return {
      menu1: false,
      menu2: false,
      btnLoading: false,
      dataLoading: false,
      unitPromotionCharge: 0,
      calculatedPromotionCharge: 0,
      numberOfDays: 0,
      paymentUrl: null,
      fromDate: "",
      toDate: "",
      alreadyOnPromotion: false,
      selectedLandlordId: "",
      selectedPropertyId: "",
      searchKey: "",
      selectedPropertyDetails: {},
      landlordList: [],
      propertyListOfSelectedLandlord: []
    };
  },
  methods: {
    sharePaymentLink() {
      let phone;
      const landlord = this.landlordList.find(landlord => {
        return landlord._id === this.selectedLandlordId;
      });
      phone = landlord.user.phone;
      window.open(
        "https://wa.me/" + phone + "?text=" + this.paymentUrl,
        "_blank"
      );
    },
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: {
          property: this.selectedPropertyId,
          numberOfDays: this.numberOfDays,
          promotionStartDate: this.fromDate,
          promotionEndDate: this.toDate,
          amount: this.calculatedPromotionCharge,
          paymentType: "KNET"
        }
      };
      const response = await createPromotionByAdmin(input);
      if (response.data.createPromotionByAdmin) {
        this.paymentUrl = response.data.createPromotionByAdmin.paymentUrl;
        this.btnLoading = false;
      } else {
        this.btnLoading = false;
      }
    },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    },
    calculatePromotionCharge() {
      const startDate = moment(this.fromDate).startOf("day");
      const endDate = moment(this.toDate).endOf("day");
      let difference = endDate.diff(startDate, "days") + 1;
      if (difference <= 0) {
        difference = 1;
      }
      this.numberOfDays = difference;
      this.calculatedPromotionCharge = difference * this.unitPromotionCharge;
    },
    clearForm() {
      this.$refs.promotionForm.reset();
      this.paymentUrl = "";
    },
    filterLandlord(landlordInfo) {
      if (landlordInfo.user.active) {
        return true;
      }
      return false;
    },
    showFullName(item) {
      return item.user.firstName + " " + item.user.lastName;
    }
  },
  apollo: {
    getLandlords() {
      return {
        query: require("../../../landlord/api/queries/landlord_query.graphql"),
        variables: {
          input: {
            limit: 10,
            skip: 0
          },
          filter: {
            searchKey: this.searchKey || ""
          }
        },
        result({ data }) {
          this.landlordList = this.$format.cloneVariable(
            data.getLandlords.landlords
          );
        }
      };
    }
  },
  watch: {
    toDate() {
      if (!this.fromDate) {
        return null;
      }
      this.calculatePromotionCharge();
    },
    selectedLandlordId(val) {
      this.dataLoading = true;
      this.$apollo
        .query({
          query: require("../../api/queries/get_property_by_landlord_for_admin.graphql"),
          variables: {
            input: {
              limit: 0,
              skip: 0
            },
            landlordId: val
          }
        })
        .then(data => {
          this.dataLoading = false;
          this.propertyListOfSelectedLandlord = this.$format.cloneVariable(
            data.data.getPropertyByLandlordForAdmin.properties
          );
        });
    },
    searchKey() {
      this.$apollo.queries.getLandlords.refetch({
        input: {
          limit: 10,
          skip: 0
        },
        filter: {
          searchKey: this.searchKey || "",
          sortBy: "",
          sortDesc: false
        }
      });
    },
    selectedPropertyId(val) {
      this.dataLoading = true;
      this.$apollo
        .query({
          query: require("../../api/queries/get_property_by_id.graphql"),
          variables: { id: val }
        })
        .then(data => {
          this.alreadyOnPromotion = this.$format.cloneVariable(
            data.data.getPropertyById.isPromoted
          );
          this.selectedPropertyDetails = data.data.getPropertyById;
        });
      this.$apollo
        .query({
          query: require("../../api/queries/get_promotion_by_property_id.graphql"),
          variables: {
            propertyId: val,
            input: {
              limit: 10,
              skip: 0
            }
          }
        })
        .then(data => {
          this.dataLoading = false;
          if (data.data.getPromotionByPropertyId.promotions[0].isExpired) {
            this.dataLoading = false;
            throw "Promotion Expired";
          }
          if (this.alreadyOnPromotion) {
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("promotions.alreadyOnPromotion"),
              color: "green"
            });
            let rawDate = new Date(
              parseInt(
                data.data.getPromotionByPropertyId.promotions[0]
                  .promotionEndDate
              )
            );
            this.fromDate = this.dateFormat(rawDate);
          }
        })
        .catch(() => {
          this.fromDate = "";
          this.toDate = "";
        });
      this.dataLoading = true;
      this.$apollo
        .query({
          query: require("@/settings/api/queries/fee/get_promotion_charges_query.graphql"),
          fetchPolicy: "no-cache",
          variables: {
            input: {
              limit: 50,
              skip: 0
            }
          }
        })
        .then(({ data }) => {
          this.dataLoading = false;
          data.getAllPromotionCharges.promotionCharges.forEach(
            eachPromotionCharge => {
              if (
                eachPromotionCharge.isActive &&
                eachPromotionCharge.propertyType._id ===
                  this.selectedPropertyDetails.propertyType._id
              ) {
                this.unitPromotionCharge = eachPromotionCharge.price;
              }
            }
          );
          if (!this.unitPromotionCharge) {
            this.unitPromotionCharge =
              data.getAllPromotionCharges.defaultPromotionCharge;
          }
        });
    }
  }
};
</script>
